import { render } from "./MLoadingIcon.vue?vue&type=template&id=66b3adb5"
const script = {}
script.render = render

export default script